export default __webpack_public_path__ + "static/media/6.69d4dd1c.png";